import { motion } from "framer-motion";
import { useLanguage } from "@/contexts/LanguageContext";
import { openCookieSettings } from "@/components/CookieBanner";

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-transparent border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-12 lg:py-16">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col lg:flex-row items-center justify-between gap-8"
        >
          {/* Legal links + Logo & Tagline */}
          <div className="text-center lg:text-left">
            <div className="flex flex-col items-center lg:items-start gap-1 mb-4">
              <button
                onClick={openCookieSettings}
                className="text-sm text-muted-foreground hover:text-cyan-400 transition-colors"
              >
                {t.footer.cookieSettings}
              </button>
              <a
                href="/zasady-ochrany-osobnich-udaju"
                className="text-sm text-muted-foreground hover:text-cyan-400 transition-colors"
              >
                {t.footer.privacyPolicy}
              </a>
            </div>
            <a
              href="/"
              className="text-xl font-bold text-foreground hover:opacity-80 transition-opacity"
            >
              {t.nav.logo}
            </a>
            <p className="mt-2 text-sm text-muted-foreground">
              {t.footer.tagline}
            </p>
          </div>

          {/* Copyright */}
          <div className="text-center lg:text-right">
            <p className="text-sm text-muted-foreground">
              {t.footer.copyright}
            </p>
            <p className="mt-2 text-xs" style={{ color: '#6b7280' }}>
              {t.footer.address}
            </p>
            <p className="text-xs" style={{ color: '#6b7280' }}>
              {t.footer.registry}
            </p>
          </div>
        </motion.div>

      </div>
    </footer>
  );
};
